/*
  orlea-zoom.js — Lightbox plein ecran maison (remplace Fancybox).
  Custom element <orlea-zoom> pose une fois dans le layout. Delegation sur
  document -> capte tout [data-ozoom], meme les images reinjectees par Flaunt.
  Balisage : <a href="URL_HD" data-ozoom data-ozoom-group="GROUPE">...</a>
*/
(function () {
  'use strict';
  if (window.__orleaZoomReady) return;
  window.__orleaZoomReady = true;

  var SEL = 'a[data-ozoom], [data-ozoom]';

  class OrleaZoom extends HTMLElement {
    connectedCallback() {
      if (this._built) return;
      this._built = true;
      this._items = [];
      this._index = 0;
      this._lastFocus = null;
      this._buildDom();
      this._onDocClick = this._onDocClick.bind(this);
      document.addEventListener('click', this._onDocClick, true);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this._onDocClick, true);
    }

    _buildDom() {
      this.classList.add('ozoom');
      this.setAttribute('aria-hidden', 'true');
      this.innerHTML =
        '<div class="ozoom-backdrop" data-ozoom-close></div>' +
        '<div class="ozoom-dialog" role="dialog" aria-modal="true" aria-label="Image">' +
        '  <button class="ozoom-close" type="button" aria-label="Close" data-ozoom-close>' +
        '    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.6" fill="none" stroke-linecap="round"/></svg>' +
        '  </button>' +
        '  <button class="ozoom-nav ozoom-prev" type="button" aria-label="Previous" hidden>' +
        '    <svg viewBox="0 0 24 24" width="26" height="26" aria-hidden="true"><path d="M15 5l-7 7 7 7" stroke="currentColor" stroke-width="1.6" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '  </button>' +
        '  <figure class="ozoom-stage"><img class="ozoom-img" alt=""></figure>' +
        '  <button class="ozoom-nav ozoom-next" type="button" aria-label="Next" hidden>' +
        '    <svg viewBox="0 0 24 24" width="26" height="26" aria-hidden="true"><path d="M9 5l7 7-7 7" stroke="currentColor" stroke-width="1.6" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '  </button>' +
        '</div>';

      this._img = this.querySelector('.ozoom-img');
      this._prev = this.querySelector('.ozoom-prev');
      this._next = this.querySelector('.ozoom-next');

      this.addEventListener('click', function (e) {
        if (e.target.closest('[data-ozoom-close]')) { this.close(); }
      }.bind(this));
      this._prev.addEventListener('click', this._go.bind(this, -1));
      this._next.addEventListener('click', this._go.bind(this, 1));
      this._onKey = this._onKey.bind(this);
    }

    _onDocClick(e) {
      var link = e.target.closest(SEL);
      if (!link) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
      var href = link.getAttribute('href') || link.getAttribute('data-ozoom-src');
      if (!href) return;
      e.preventDefault();
      this._collect(link);
      this.open(this._index);
    }

    // La PDP rend DEUX galeries (desktop + mobile) avec le meme groupe, une seule
    // visible selon le breakpoint. On ne garde que les liens VISIBLES
    // (offsetParent non nul) -> pas de doublon dans la navigation par fleches.
    _collect(link) {
      var group = link.getAttribute('data-ozoom-group');
      var all;
      if (group) {
        all = Array.prototype.slice.call(
          document.querySelectorAll('[data-ozoom-group="' + cssEscape(group) + '"]')
        );
      } else {
        all = [link];
      }
      all = all.filter(function (a) {
        var hasSrc = a.getAttribute('href') || a.getAttribute('data-ozoom-src');
        var visible = a.offsetParent !== null || a === link;
        return hasSrc && visible;
      });
      if (all.indexOf(link) === -1) { all = [link]; }
      this._items = all;
      this._index = Math.max(0, all.indexOf(link));
    }

    open(index) {
      this._index = index;
      this._lastFocus = document.activeElement;
      this._render();
      var multi = this._items.length > 1;
      this._prev.hidden = !multi;
      this._next.hidden = !multi;
      this.setAttribute('aria-hidden', 'false');
      this.classList.add('is-open');
      document.documentElement.classList.add('ozoom-lock');
      if (window.lenis && typeof window.lenis.stop === 'function') { window.lenis.stop(); }
      document.addEventListener('keydown', this._onKey);
      var closeBtn = this.querySelector('.ozoom-close');
      if (closeBtn) closeBtn.focus();
    }

    close() {
      if (!this.classList.contains('is-open')) return;
      this.classList.remove('is-open');
      this.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('ozoom-lock');
      if (window.lenis && typeof window.lenis.start === 'function') { window.lenis.start(); }
      document.removeEventListener('keydown', this._onKey);
      this._img.removeAttribute('src');
      if (this._lastFocus && typeof this._lastFocus.focus === 'function') {
        this._lastFocus.focus();
      }
    }

    _go(dir) {
      if (this._items.length < 2) return;
      this._index = (this._index + dir + this._items.length) % this._items.length;
      this._render();
    }

    _render() {
      var link = this._items[this._index];
      if (!link) return;
      var src = link.getAttribute('href') || link.getAttribute('data-ozoom-src');
      var inner = link.querySelector('img');
      this._img.setAttribute('alt', (inner && inner.getAttribute('alt')) || link.getAttribute('aria-label') || '');
      this._img.src = src;
    }

    _onKey(e) {
      if (e.key === 'Escape') { this.close(); }
      else if (e.key === 'ArrowLeft') { this._go(-1); }
      else if (e.key === 'ArrowRight') { this._go(1); }
      else if (e.key === 'Tab') {
        var f = this.querySelectorAll('button:not([hidden])');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }
  }

  function cssEscape(s) {
    if (window.CSS && CSS.escape) return CSS.escape(s);
    return String(s).replace(/["\\\]]/g, '\\$&');
  }

  if (!customElements.get('orlea-zoom')) {
    customElements.define('orlea-zoom', OrleaZoom);
  }
})();
